export default __webpack_public_path__ + "755f2325643703c0e5a9224bc93be1c8.svg";